import answerAPI from "../../api/answer"
import uuidv4 from "uuid/v4"
import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  order: [],
  all: [],
  answersCount: 0,
  groups: [],
  lastGroupIndex: null,
  groupSelectedIndex: null,
  lastGroupSelectedIndex: null,
  selected: [],
  lastSelected: [],
  nonFilteredAnswers: [],
  nonFilteredOrder: [],
  orderByLabel: {},
}

const getters = {
  groupLength: (state) => (groupIndex) => {
    let length = 0
    state.groups[groupIndex].map((id) => {
      if (state.all[id].merged_answer_guid_text === null) {
        length++
      }
    })
    return length
  },

  groupLastAnswerIndex: (state) => (groupIndex) => {
    let lastIndex = state.groups[groupIndex][state.groups[groupIndex].length - 1]
    if (state.all[lastIndex].merged_answer_guid_text !== null) {
      return state.all.findIndex((answer) => answer.guid_text === state.all[lastIndex].merged_answer_guid_text)
    }
    return lastIndex
  },

  isSelectedAnswerMerged: (state) => {
    return (
      state.all[state.order[state.selected[0]]].merged_answers_count !== undefined &&
      state.all[state.order[state.selected[0]]].merged_answers_count > 1
    )
  },

  hasGroups: (state) => {
    return state.groups.length > 0
  },

  isLastOfGroup: (state) => (order) => {
    let isLast = false
    state.groups.map((group) => {
      if (group.indexOf(state.order[order]) === group.length - 1) {
        isLast = true
        return
      }
    })
    return isLast
  },

  getSelectedCount: (state) => {
    return state.selected.length
  },

  isFirst: (state, getters, rootState) => (order, label_guid) => {
    switch (rootState.grid.gridMode) {
      case "group": {
        // console.log("isFirst? ", order)

        if (order === 0) {
          return true
        }

        let isFirst = false
        let answersInGroupsCount = 0
        let realIndex = order

        // check if it has groups
        if (state.lastGroupIndex !== null) {
          // and if current order is not after all groups
          if (order <= state.order.indexOf(getters["groupLastAnswerIndex"](state.lastGroupIndex)) + 2) {
            for (const [groupIndex, group] of state.groups.entries()) {
              // check if order is the first of the group
              if (group[0] === state.order[order]) {
                // console.log("IS FIRST OF THE GROUP!!")
                isFirst = true
                break
              }

              answersInGroupsCount += getters["groupLength"](groupIndex) + 1

              // console.log("group ", groupIndex, " length ", answersInGroupsCount)

              // console.log("next group order ", state.order.indexOf(getters["groupLastAnswerIndex"](groupIndex)) + 2)

              // check if order is just after the group's EOL => order is necessarily first
              if (state.order.indexOf(getters["groupLastAnswerIndex"](groupIndex)) + 2 === order) {
                // console.log("IS JUST AFTER THE GROUP!!")
                isFirst = true
                break
              }

              // check if order is not in the current group or EOL
              if (!(group.includes(state.order[order]) || group.includes(state.order[order - 1]))) {
                // console.log("IS NOT IN THE CURRENT GROUP OR EOL!!")
                continue
              }

              // case multiline group
              if (
                getters["groupLength"](groupIndex) >= rootState.grid.realItemsPerLine &&
                (order - (answersInGroupsCount - getters["groupLength"](groupIndex) - 1)) %
                  rootState.grid.realItemsPerLine ===
                  0
              ) {
                isFirst = true
                break
              }
            }

            if (isFirst === true) {
              return true
            }
            return false
          } else {
            // console.log(order, " is after all groups")
            state.groups.map((group, groupIndex) => {
              answersInGroupsCount += getters["groupLength"](groupIndex) + 1
            })
          }
          realIndex = order - answersInGroupsCount
        }

        if (realIndex % rootState.grid.realItemsPerLine === 0) {
          return true
        }

        return false
      }
      case "label": {
        const answerLabelIndex = rootState.labels.selected.findIndex((guid) => guid === label_guid)
        if (order % rootState.grid.realItemsPerLabel[answerLabelIndex] === 0) {
          return true
        }
        return false
      }
      case "grid": {
        if (order % rootState.grid.realItemsPerLine === 0) {
          return true
        }
        return false
      }
    }
  },

  getLabelName: (state, getters, rootState, rootGetters) => (index) => {
    return rootGetters["labels/getName"](state.all[index].question_labels_guid_text)
  },

  getLabelColors: (state, getters, rootState, rootGetters) => (index) => {
    return rootGetters["labels/getLabelColors"](state.all[index].question_labels_guid_text)
  },

  getAnswersCountForLabel: (state) => (label) => {
    return state.all.filter((answer) => answer.question_labels_guid_text === label.guid_text).length
  },

  getSelectedAnswersCountForLabel: (state) => (label) => {
    return state.selected.filter((id) => state.all[state.order[id]].question_labels_guid_text === label.guid_text)
      .length
  },

  selectedIsAGroup: (state) => {
    let selectedIsAGroup = false
    if (state.selected.length > 0) {
      state.groups.map((group) => {
        if (group.every((index) => state.selected.includes(index))) {
          selectedIsAGroup = true
          return
        }
      })
    }
    return selectedIsAGroup
  },

  oneSelectedIsInAGroup: (state) => {
    let oneSelectedIsInAGroup = false
    if (state.selected.length === 1) {
      state.groups.map((group) => {
        if (group.includes(state.selected[0])) {
          oneSelectedIsInAGroup = true
          return
        }
      })
    }
    return oneSelectedIsInAGroup
  },
}

const actions = {
  saveAnswers() {
    let question = getItem("question[" + this.getters["question/getQuestionGuid"] + "]")
    question.answers = state.all
    setItem({ name: "question[" + question.guid_text + "]", value: question })
    setItem({
      name: "answersOrder[" + this.getters["question/getQuestionGuid"] + "]",
      value: state.order,
    })
  },

  updateAnswersOrder({ commit, state, rootState, dispatch }) {
    if (state.nonFilteredOrder.lenght > 0) {
      return
    }

    let orderedAnswers = []
    state.order.map((id, order) => {
      orderedAnswers.push(state.all[id].guid_text)
      state.all[id].order = order + 1
    })

    if (!rootState.app.isOffline) {
      answerAPI.updateAnswersOrder({
        answers: orderedAnswers,
      })
    } else {
      commit(
        "offline/addApiCallToStack",
        {
          api: "answer",
          method: "updateAnswersOrder",
          arg: { answers: orderedAnswers },
        },
        { root: true }
      )
    }

    setItem({ name: "answersOrder[" + state.all[0].question_guid_text + "]", value: state.order })
  },

  associateLabelToSelectedAnswers({ commit, state, rootState }, label) {
    let guids = []
    let oldLabelGuids = []

    state.selected.map((order) => {
      guids.push(state.all[state.order[order]].guid_text)
      oldLabelGuids.push(state.all[state.order[order]].question_labels_guid_text)
    })

    this.dispatch("answers/associateLabel", {
      guids: guids,
      question_labels_guid: label.guid_text,
    })

    if (rootState.grid.gridMode === "label" && oldLabelGuids.length > 0) {
      oldLabelGuids.map((oldLabelGuid) => {
        commit("answers/setOrderByLabel", oldLabelGuid, { root: true })
      })
    }
  },

  associateLabel({ commit, state, rootState }, { guids, question_labels_guid }) {
    // Case merged answer, set for all children
    const answers = state.all.filter((answer) => guids.includes(answer.guid_text))
    answers.map((answer) => {
      if (answer.merged_answers_count !== undefined) {
        state.all
          .filter((originalAnswer) => originalAnswer.merged_answer_guid_text === answer.guid_text)
          .map((originalAnswer) => guids.push(originalAnswer.guid_text))
      }
    })

    if (!rootState.app.isOffline) {
      answerAPI.associateLabel({
        guids: guids,
        question_labels_guid: question_labels_guid,
      })
    } else {
      commit(
        "offline/addApiCallToStack",
        {
          api: "answer",
          method: "associateLabel",
          arg: {
            guids: guids,
            question_labels_guid: question_labels_guid,
          },
        },
        { root: true }
      )
    }

    this.commit("answers/associateLabelToAnswer", { guids, question_labels_guid })

    if (rootState.grid.deselect === true) {
      this.commit("answers/removeSelected")
    }

    this.dispatch("answers/saveAnswers")

    if (!rootState.app.isOffline) {
      this.dispatch("socket/associateLabel", {
        answerGuids: guids,
        labelGuid: question_labels_guid,
      })
    }
  },

  async restoreAnswers({ rootState }, answers) {
    if (rootState.app.isOffline) {
      let answersToAdd = []
      answers.map((answer) => {
        answersToAdd.push({ ...answer })
        answersToAdd[answersToAdd.length - 1].guid_text = uuidv4().toUpperCase()
        answersToAdd[answersToAdd.length - 1].order = state.answersCount + 1
        answersToAdd[answersToAdd.length - 1].number = state.answersCount + 1
        answersToAdd[answersToAdd.length - 1].merged_answer_guid_text = null
        answersToAdd[answersToAdd.length - 1].isSelected = false
        answersToAdd[answersToAdd.length - 1].isGroupTopLeft = false
        answersToAdd[answersToAdd.length - 1].isFirstTop = false
        answersToAdd[answersToAdd.length - 1].isTop = false
        this.commit("answers/addAnswer", answersToAdd[answersToAdd.length - 1])
      })

      this.dispatch("answers/saveAnswers")

      this.commit(
        "offline/addApiCallToStack",
        {
          api: "answer",
          method: "newAnswers",
          arg: answersToAdd,
        },
        { root: true }
      )
    } else {
      answers.map(async (answer) => {
        await this.dispatch(
          "socket/pushAnswer",
          {
            questionGuid: answer.question_guid_text,
            responseTextWithLabelGuid: answer.text + "|" + answer.question_labels_guid_text,
          },
          null,
          { root: true }
        )
      })
    }
  },

  async newAnswer({ state, rootState }, { text, label_guid = null }) {
    if (rootState.app.isOffline) {
      let answer = {
        guid_text: uuidv4().toUpperCase(),
        text: text,
        order: state.answersCount + 1,
        question_guid_text: this.getters["question/getQuestionGuid"],
        question_labels_guid_text: label_guid !== null ? label_guid : this.getters["labels/getDefaultGuid"],
        user_guid_text: this.getters["pilot/guid"],
        merged_answer_guid_text: null,
        chars_count: text.length,
        likes_count: 0,
        number: state.answersCount + 1,
        isSelected: false,
        isGroupTopLeft: false,
        isFirstTop: false,
        isTop: false,
      }
      this.commit("answers/addAnswer", answer)
      this.commit("answers/setOrderByLabel", answer.question_labels_guid_text)
      this.dispatch("answers/saveAnswers")

      let answerToStack = { ...answer }
      this.commit(
        "offline/addApiCallToStack",
        {
          api: "answer",
          method: "newAnswers",
          arg: [answerToStack],
        },
        { root: true }
      )
    } else {
      await this.dispatch(
        "socket/pushAnswer",
        {
          questionGuid: this.getters["question/getQuestionGuid"],
          responseTextWithLabelGuid:
            text + "|" + (label_guid !== null ? label_guid : this.getters["labels/getDefaultGuid"]),
        },
        null,
        { root: true }
      )
    }
  },

  deleteModelAnswer({ state, commit, dispatch }) {
    let modelAnswerId
    state.all.forEach((answer, index) => {
      if (answer.text === "Modèle de contribution") {
        modelAnswerId = index
        return
      }
    })

    console.log("modelAnswerId", modelAnswerId)

    if (modelAnswerId !== undefined) {
      commit("selectAnswer", modelAnswerId)
      dispatch("deleteSelected")
    }
  },

  deleteSelected({ commit, dispatch, state, rootState }) {
    // Add merged answers if exist(s)
    state.selected.map((order) => {
      const answer = state.all[state.order[order]]
      const childAnswersIndexes = state.all.reduce((result, a, index) => {
        if (a.merged_answer_guid_text === answer.guid_text) {
          result.push(index)
        }
        return result
      }, [])
      if (childAnswersIndexes.length > 0) {
        commit("unmerge", { parentAnswerOrder: order })
        commit("selectAnswer", order)
        childAnswersIndexes.map((childAnswerIndex) => {
          commit("selectAnswer", state.order.indexOf(childAnswerIndex))
        })
      }
    })

    const selectedAnswers = state.selected.map((order) => state.all[state.order[order]])
    commit("undo/addDeletedAnswers", { answers: selectedAnswers }, { root: true })

    const selectedAnswerGuids = state.selected.map((order) => state.all[state.order[order]].guid_text)
    if (!rootState.app.isOffline) {
      dispatch(
        "socket/deleteAnswers",
        {
          guids: selectedAnswerGuids,
        },
        { root: true }
      )

      answerAPI.deleteAnswers(selectedAnswerGuids)
    } else {
      this.commit(
        "offline/addApiCallToStack",
        {
          api: "answer",
          method: "deleteAnswers",
          arg: selectedAnswerGuids,
        },
        { root: true }
      )
    }
    commit("deleteSelected")
    dispatch("saveAnswers")
  },

  async setOptionsFromSaved({ commit, dispatch }) {
    let options = getItem("labelsOptions")
    if (options) {
      commit("setOptions", options)
    }
  },

  async setSelectedFromSaved({ commit, dispatch }) {
    let selected = getItem("selectedLabels[" + state.all[0].question_guid_text + "]")
    if (selected) {
      commit("setSelected", selected)
      selected.map((guid) => commit("answers/setOrderByLabel", guid, { root: true }))
    }
  },

  async updateMergedAnswer({ commit, rootState }, { answer_guid, merged_answer_guid }) {
    if (!rootState.app.isOffline) {
      answerAPI.updateMergedAnswer({ answer_guid, merged_answer_guid })
    } else {
      commit(
        "offline/addApiCallToStack",
        {
          api: "answer",
          method: "updateMergedAnswer",
          arg: { answer_guid, merged_answer_guid },
        },
        { root: true }
      )
    }
  },
}

const mutations = {
  merge(state, { withFirst = false, persist = true }) {
    let childAnswersStartAt = 0
    let parentAnswer = state.all[state.order[state.selected[state.selected.length - 1]]]
    if (withFirst === true) {
      childAnswersStartAt = 1
      parentAnswer = state.all[state.order[state.selected[0]]]
    }

    let newOrder = [...state.order]
    state.selected
      .slice(childAnswersStartAt, childAnswersStartAt === 0 ? -1 : state.selected.length)
      .map((childAnswerOrder) => {
        const childAnswer = state.all[state.order[childAnswerOrder]]

        childAnswer.merged_answer_guid_text = parentAnswer.guid_text

        // Case display by labels
        if (state.orderByLabel[childAnswer.question_labels_guid_text]) {
          const childAnswerOrderByLabel = state.orderByLabel[childAnswer.question_labels_guid_text].indexOf(
            state.order[childAnswerOrder]
          )
          state.orderByLabel[childAnswer.question_labels_guid_text].splice(childAnswerOrderByLabel, 1)
        }

        // Case group
        if (state.groups.length > 0) {
          state.groups.map((group) => {
            const groupAnswerIndex = group.indexOf(state.order[childAnswerOrder])
            if (groupAnswerIndex !== -1) {
              group.splice(groupAnswerIndex, 1)
            }
          })
        }

        newOrder.splice(newOrder.indexOf(state.order[childAnswerOrder]), 1)

        this.dispatch("answers/associateLabel", {
          guids: [childAnswer.guid_text],
          question_labels_guid: parentAnswer.question_labels_guid_text,
        })

        // Case parentAnswer has no children
        if (parentAnswer.merged_answers_count === undefined) {
          parentAnswer.merged_answers_count = 2
          parentAnswer.merged_likes_count = parentAnswer.likes_count
        } else {
          parentAnswer.merged_answers_count++
        }

        // Case childAnswer is already a set of merged answers
        if (childAnswer.merged_answers_count !== undefined) {
          const childAnswers = state.all.filter((answer) => answer.merged_answer_guid_text === childAnswer.guid_text)

          childAnswers.map((answer) => {
            answer.merged_answer_guid_text = parentAnswer.guid_text
            this.dispatch("answers/associateLabel", {
              guids: [answer.guid_text],
              question_labels_guid: parentAnswer.question_labels_guid_text,
            })
            if (persist === true) {
              this.dispatch("answers/updateMergedAnswer", {
                answer_guid: answer.guid_text,
                merged_answer_guid: parentAnswer.guid_text,
              })
            }
          })

          parentAnswer.merged_answers_count += childAnswers.length
          parentAnswer.merged_likes_count += childAnswer.merged_likes_count

          delete childAnswer.merged_answers_count
          delete childAnswer.merged_likes_count
        } else {
          parentAnswer.merged_likes_count += childAnswer.likes_count
        }

        parentAnswer.merged_answer_guid_text = null

        // persist to DB
        if (persist === true) {
          this.dispatch("answers/updateMergedAnswer", {
            answer_guid: childAnswer.guid_text,
            merged_answer_guid: parentAnswer.guid_text,
          })
        }
      })

    state.order = newOrder

    this.commit("answers/removeSelected")

    this.dispatch("answers/saveAnswers")
  },

  unmerge(state, { parentAnswerOrder }) {
    const mergeAnswer = state.all[state.order[parentAnswerOrder]]
    const childAnswers = state.all.filter((answer) => answer.merged_answer_guid_text === mergeAnswer.guid_text)

    delete mergeAnswer.merged_answers_count
    delete mergeAnswer.merged_likes_count

    childAnswers.map((answer) => {
      let answerIndex = state.all.findIndex((originalAnswer) => originalAnswer.guid_text === answer.guid_text)
      answer.merged_answer_guid_text = null
      this.dispatch("answers/updateMergedAnswer", {
        answer_guid: answer.guid_text,
        merged_answer_guid: null,
      })
      state.order.splice(parentAnswerOrder + 1, 0, answerIndex)
      // Case display by labels
      if (state.orderByLabel[answer.question_labels_guid_text]) {
        const mergeAnswerOrderByLabel = state.orderByLabel[mergeAnswer.question_labels_guid_text].indexOf(
          state.order[parentAnswerOrder]
        )
        state.orderByLabel[answer.question_labels_guid_text].splice(mergeAnswerOrderByLabel + 1, 0, answerIndex)
      }
      // Case group
      if (state.groups.length > 0) {
        state.groups.map((group) => {
          const groupParentAnswerIndex = group.indexOf(state.order[parentAnswerOrder])
          if (groupParentAnswerIndex !== -1) {
            group.splice(groupParentAnswerIndex + 1, 0, answerIndex)
          }
        })
      }
    })
    this.dispatch("answers/updateAnswersOrder")

    this.commit("answers/removeSelected")

    this.dispatch("answers/saveAnswers")

    // persist to DB
    this.dispatch("answers/updateMergedAnswer", {
      answer_guid: mergeAnswer.guid_text,
      merged_answer_guid: null,
    })
  },

  deleteSelected(state) {
    const answerIds = [...state.selected.map((order) => state.order[order])].sort((a, b) => a - b)
    let newOrder = [...state.order]
    let deletedAnswersCount = 0
    answerIds.map((id) => {
      state.all.splice(id - deletedAnswersCount, 1)
      newOrder.splice(newOrder.indexOf(id - deletedAnswersCount), 1)
      // update ordered answers that > id => -1
      newOrder.map((newOrderId, order) => {
        if (newOrderId > id - deletedAnswersCount) {
          newOrder[order]--
          state.all[newOrder[order]].number--
        }
      })
      deletedAnswersCount++
    })

    state.order = newOrder
    // orderByLabel ...
    for (let labelGuid in state.orderByLabel) {
      this.commit("answers/setOrderByLabel", labelGuid)
    }
    state.answersCount -= state.selected.length
    state.selected = []
  },

  addAnswer(state, answer) {
    state.all.splice(state.answersCount, 0, answer)
    // check if EOLs exist and update them
    if (state.answersCount < state.all.length) {
      let newOrder = [...state.order]
      for (let id = state.answersCount; id < state.all.length; id++) {
        newOrder[state.order.indexOf(id)]++
      }
      state.order = newOrder
    }
    state.order.push(state.answersCount)
    state.answersCount++
  },

  addAnswerFromSocket(state, { results, question_guid }) {
    if (results.length === 0) {
      return
    }

    // case refresh
    if (state.answersCount === 0 && results.length > 0) {
      let answers = []
      let likesMax = 0
      results.map((result, index) => {
        answers.push({
          guid_text: result.id,
          text: result.label,
          order: index + 1,
          question_labels_guid_text: result.category.toUpperCase(),
          question_guid_text: question_guid,
          user_guid_text: result.author,
          merged_answer_guid_text: null,
          chars_count: result.label.length,
          likes_count: result.count,
          number: index + 1,
          isSelected: false,
          isGroupTopLeft: false,
          isFirstTop: false,
          isTop: false,
        })

        if (likesMax < result.likes_count) {
          likesMax = result.likes_count
        }
      })

      this.commit("question/setLikesMax", likesMax, {
        root: true,
      })

      state.lastGroupIndex = getItem("lastGroupIndex[" + answers[0].question_guid_text + "]")
      state.groups = getItem("groups[" + answers[0].question_guid_text + "]") || []
      state.order = getItem("answersOrder[" + answers[0].question_guid_text + "]") || [...answers.keys()]

      state.all = answers
      if (state.order.length === 0) {
        state.order = [...state.all.keys()]
      }
      state.answersCount = answers.filter((answer) => !answer.isEOL).length

      this.commit("answers/setTops", this.state.grid.tops)
      this.dispatch("answers/saveAnswers")
      return
    }

    // case it is a like or an unlike
    if (results.length === state.answersCount) {
      let likesMax = 0
      state.all.forEach((answer, index) => {
        if (index >= state.answersCount) {
          return
        }
        let result = results.find((result) => result.id.toUpperCase() === answer.guid_text)
        if (result !== undefined) {
          // Case child merged answer
          if (answer.merged_answer_guid_text !== null) {
            state.all.find(
              (parentAnswer) => parentAnswer.guid_text === answer.merged_answer_guid_text
            ).merged_likes_count += result.count - answer.likes_count
          }
          // Case parent merged answer
          if (answer.merged_answers_count !== undefined) {
            answer.merged_likes_count += result.count - answer.likes_count
          }
          answer.likes_count = result.count
        }
        if (likesMax < answer.likes_count) {
          likesMax = answer.likes_count
        }
      })

      if (state.nonFilteredAnswers.length) {
        likesMax = 0
        state.nonFilteredAnswers.forEach((answer, index) => {
          if (index >= state.answersCount) {
            return
          }
          let result = results.find((result) => result.id.toUpperCase() === answer.guid_text)
          if (result !== undefined) {
            // Case child merged answer
            if (answer.merged_answer_guid_text !== null) {
              state.all.find(
                (parentAnswer) => parentAnswer.guid_text === answer.merged_answer_guid_text
              ).merged_likes_count += result.count - answer.likes_count
            }
            // Case parent merged answer
            if (answer.merged_answers_count !== undefined) {
              answer.merged_likes_count += result.count - answer.likes_count
            }
            answer.likes_count = result.count
          }
          if (likesMax < answer.likes_count) {
            likesMax = answer.likes_count
          }
        })
      }

      this.commit("question/setLikesMax", likesMax, {
        root: true,
      })
      this.commit("answers/setTops", this.state.grid.tops)
      this.commit("answers/setFilter", this.state.grid.filter)
      this.dispatch("answers/saveAnswers")
      return
    }

    for (let i = state.answersCount; i < results.length; i++) {
      const lastSocketResult = results[i]
      const answer = {
        guid_text: lastSocketResult.id,
        text: lastSocketResult.label,
        order: state.answersCount + 1,
        question_labels_guid_text: lastSocketResult.category.toUpperCase(),
        question_guid_text: question_guid,
        user_guid_text: lastSocketResult.author,
        merged_answer_guid_text: null,
        chars_count: lastSocketResult.label.length,
        likes_count: lastSocketResult.count,
        number: state.answersCount + 1,
        isSelected: false,
        isGroupTopLeft: false,
        isFirstTop: false,
        isTop: false,
      }

      this.commit("question/setLikesMax", answer.likes_count, {
        root: true,
      })

      // check if EOLs exist and update them
      if (state.answersCount < state.all.length) {
        let newOrder = [...state.order]
        for (let id = state.answersCount; id < state.all.length; id++) {
          newOrder[state.order.indexOf(id)]++
        }
        state.order = newOrder
      }

      state.all.splice(state.answersCount, 0, answer)
      state.order.push(state.answersCount)

      // check if orderByLabel exists and udpate it
      if (state.orderByLabel[answer.question_labels_guid_text]) {
        state.orderByLabel[answer.question_labels_guid_text].push(state.answersCount)
      }

      state.answersCount++
    }

    this.commit("answers/setTops", this.state.grid.tops)
    this.dispatch("answers/saveAnswers")
  },

  setOrderByLabel(state, guid) {
    state.orderByLabel[guid] = state.order.filter((id) => state.all[id].question_labels_guid_text === guid)
    /*setItem({
      name: "orderByLabel[" + state.all[0].question_guid_text + "]",
      value: state.orderByLabel,
    })*/
  },

  removeAllOrderByLabel(state) {
    state.orderByLabel = {}
  },

  removeOrderByLabel(state, guid) {
    delete state.orderByLabel[guid]
  },

  selectAnswersWithLabel(state, question_labels_guid) {
    this.commit("answers/removeSelected")

    state.all.map((answer, id) => {
      if (answer.question_labels_guid_text === question_labels_guid) {
        state.selected.push(state.order.indexOf(id))
      }
    })
  },

  associateLabelToAnswer(state, { guids, question_labels_guid }) {
    state.all
      .filter((answer) => guids.includes(answer.guid_text))
      .map((answer) => (answer.question_labels_guid_text = question_labels_guid))
    this.commit("answers/setOrderByLabel", question_labels_guid)
  },

  setAnswers(state, answers) {
    if (answers.length > 0) {
      state.lastGroupIndex = getItem("lastGroupIndex[" + answers[0].question_guid_text + "]")
      state.groups = getItem("groups[" + answers[0].question_guid_text + "]") || []
      state.order = getItem("answersOrder[" + answers[0].question_guid_text + "]") || [...answers.keys()]

      let answersWithoutLabel = []
      state.all = answers
      state.all.map((answer, id) => {
        if (answer.question_labels_guid_text === null) {
          answersWithoutLabel.push(answer.guid_text)
          answer.question_labels_guid_text = this.getters["labels/getDefaultGuid"]
        }

        answer.number = state.order.indexOf(id) + 1
        answer.isSelected = false
        answer.isGroupTopLeft = false
        answer.isFirstTop = false
        answer.isTop = false

        // Case merged answer
        if (answer.merged_answer_guid_text !== null) {
          const parentAnswerOrder = state.order.indexOf(
            state.all.findIndex((parentAnswer) => parentAnswer.guid_text === answer.merged_answer_guid_text)
          )
          if (state.order.indexOf(id) !== -1 && parentAnswerOrder !== -1) {
            this.commit("answers/selectAnswer", id)
            this.commit("answers/selectAnswer", state.order[parentAnswerOrder])
            this.commit("answers/merge", {
              withFirst: false,
              persist: false,
            })
          }
        }
      })

      if (answersWithoutLabel.length > 0) {
        this.dispatch("associateLabel", {
          guids: answersWithoutLabel,
          question_labels_guid: this.getters["labels/getDefaultGuid"],
        })
      }

      state.answersCount = answers.filter((answer) => !answer.isEOL).length
      this.commit("answers/setTops", this.state.grid.tops)

      return
    }

    state.order = []
    state.all = []
    state.answersCount = 0
  },

  setTops(state, tops) {
    let topAnswers = [...state.all]

    topAnswers = topAnswers
      .sort(
        (a, b) =>
          (b.merged_likes_count ? b.merged_likes_count : b.likes_count) -
          (a.merged_likes_count ? a.merged_likes_count : a.likes_count)
      )
      .slice(0, tops === "10%" ? Math.ceil(state.all.length / 10) : parseInt(tops))

    // reset first
    state.all
      .filter((answer) => answer.isFirstTop)
      .map((answer) => {
        answer.isFirstTop = false
      })
    state.all
      .filter((answer) => answer.isTop)
      .map((answer) => {
        answer.isTop = false
      })

    let firstTopAnswer = topAnswers[0]
    topAnswers.map((topAnswer) => {
      if (
        (topAnswer.merged_likes_count ? topAnswer.merged_likes_count : topAnswer.likes_count) ===
        (firstTopAnswer.merged_likes_count ? firstTopAnswer.merged_likes_count : firstTopAnswer.likes_count)
      ) {
        state.all.filter((answer) => answer.guid_text === topAnswer.guid_text)[0].isFirstTop = true
      } else {
        state.all.filter((answer) => answer.guid_text === topAnswer.guid_text)[0].isTop = true
      }
    })
  },

  setOrderedBy(state, { orderedBy, labelGuidsOrdered }) {
    let sortAttr,
      sortOrder = "DESC"
    switch (orderedBy) {
      case "likes":
        sortAttr = "likes_count"
        break
      case "numbers":
        sortAttr = "number"
        sortOrder = "ASC"
        break
      case "reorder":
        state.all.map((answer, id) => (answer.number = state.order.indexOf(id) + 1))
        return
    }

    if (orderedBy.startsWith("labels")) {
      let sortedAnswers = [...state.order]
      sortedAnswers.sort((a, b) => {
        return (
          labelGuidsOrdered.indexOf(state.all[a].question_labels_guid_text) +
          (orderedBy === "labelsNumbers" ? state.all[a].number : 0) -
          (labelGuidsOrdered.indexOf(state.all[b].question_labels_guid_text) +
            (orderedBy === "labelsNumbers" ? state.all[b].number : 0))
        )
      })

      if (orderedBy === "labelsNumbers") {
        let sortedAnswersByLabel = []
        labelGuidsOrdered.forEach((labelGuid) => {
          sortedAnswersByLabel[labelGuid] = sortedAnswers
            .filter((id) => state.all[id].question_labels_guid_text === labelGuid)
            .sort((a, b) => state.all[a].number - state.all[b].number)
        })
        sortedAnswers = []
        labelGuidsOrdered.forEach((labelGuid) => {
          sortedAnswers = sortedAnswers.concat(sortedAnswersByLabel[labelGuid])
        })
      }

      if (orderedBy === "labelsLikes") {
        let sortedAnswersByLabel = []
        labelGuidsOrdered.forEach((labelGuid) => {
          sortedAnswersByLabel[labelGuid] = sortedAnswers
            .filter((id) => state.all[id].question_labels_guid_text === labelGuid)
            .sort(
              (a, b) =>
                (state.all[b].merged_likes_count ? state.all[b].merged_likes_count : state.all[b].likes_count) -
                (state.all[a].merged_likes_count ? state.all[a].merged_likes_count : state.all[a].likes_count)
            )
        })
        sortedAnswers = []
        labelGuidsOrdered.forEach((labelGuid) => {
          sortedAnswers = sortedAnswers.concat(sortedAnswersByLabel[labelGuid])
        })
      }

      state.order = sortedAnswers

      this.dispatch("answers/updateAnswersOrder")

      return
    }

    if (state.groups.length > 0) {
      // if answers are inline grouped, first sort all grouped answers
      state.groups.map((group, groupIndex) => {
        let sortedAnswers = []
        group.map((id) => {
          let answer = state.all[id]
          answer.id = id
          sortedAnswers.push(answer)
        })
        sortedAnswers.sort((a, b) => {
          let aComp = a[sortAttr]
          let bComp = b[sortAttr]

          // Case merged answer
          if (a.merged_likes_count !== undefined && orderedBy === "likes") {
            aComp = a.merged_likes_count
          }
          if (b.merged_likes_count !== undefined && orderedBy === "likes") {
            bComp = b.merged_likes_count
          }

          if (sortOrder === "ASC") {
            return aComp - bComp
          } else {
            return bComp - aComp
          }
        })
        let sortedOrders = []
        sortedAnswers.map((answer) => sortedOrders.push(answer.id))
        state.order.splice(state.order.indexOf(group[0]), group.length, ...sortedOrders)
        state.groups[groupIndex] = sortedOrders
      })

      // then sort ungrouped answers
      let lastEOLOrder = state.order.indexOf(
        state.groups[state.lastGroupIndex][state.groups[state.lastGroupIndex].length - 1]
      )
      let sortedUngroupedOrders = [...state.order.slice(lastEOLOrder + 2)]
      let sortedUngroupedAnswers = []
      sortedUngroupedOrders.map((id) => {
        let answer = state.all[id]
        answer.id = id
        sortedUngroupedAnswers.push(answer)
      })
      sortedUngroupedAnswers.sort((a, b) => {
        let aComp = a[sortAttr]
        let bComp = b[sortAttr]

        // Case merged answer
        if (a.merged_likes_count !== undefined && orderedBy === "likes") {
          aComp = a.merged_likes_count
        }
        if (b.merged_likes_count !== undefined && orderedBy === "likes") {
          bComp = b.merged_likes_count
        }

        if (sortOrder === "ASC") {
          return aComp - bComp
        } else {
          return bComp - aComp
        }
      })
      sortedUngroupedOrders = []
      sortedUngroupedAnswers.map((answer) => sortedUngroupedOrders.push(answer.id))

      state.order.splice(lastEOLOrder + 2, sortedUngroupedOrders.length, ...sortedUngroupedOrders)

      setItem({
        name: "groups[" + state.all[0].question_guid_text + "]",
        value: state.groups,
      })
    } else {
      let sortedAnswers = [...state.all]
      sortedAnswers.sort((a, b) => {
        let aComp = a[sortAttr]
        let bComp = b[sortAttr]

        // Case merged answer
        if (a.merged_likes_count !== undefined && orderedBy === "likes") {
          aComp = a.merged_likes_count
        }
        if (b.merged_likes_count !== undefined && orderedBy === "likes") {
          bComp = b.merged_likes_count
        }

        if (sortOrder === "ASC") {
          return aComp - bComp
        } else {
          return bComp - aComp
        }
      })

      let sortedAnswersGuids = []
      sortedAnswers.map((answer) => {
        sortedAnswersGuids.push(answer.guid_text)
      })

      state.order = []
      state.all.map((answer, id) => {
        state.order[sortedAnswersGuids.indexOf(answer.guid_text)] = id
      })

      if (Object.keys(state.orderByLabel).length > 0) {
        for (const question_guid in state.orderByLabel) {
          this.commit("answers/setOrderByLabel", question_guid)
        }
      }
    }
    this.dispatch("answers/updateAnswersOrder")
  },

  setFilter(state, filter) {
    if (state.nonFilteredAnswers.length) {
      state.all = state.nonFilteredAnswers
      state.order = state.nonFilteredOrder
      state.nonFilteredAnswers = []
      state.nonFilteredOrder = []
    }

    if (filter === null) {
      return
    }

    let filteredAnswers = [...state.all]

    switch (filter) {
      case "top10":
        filteredAnswers = filteredAnswers
          .sort(
            (a, b) =>
              (b.merged_likes_count ? b.merged_likes_count : b.likes_count) -
              (a.merged_likes_count ? a.merged_likes_count : a.likes_count)
          )
          .slice(0, 10)
        break
      case "flop10":
        filteredAnswers = filteredAnswers
          .sort(
            (a, b) =>
              (a.merged_likes_count ? a.merged_likes_count : a.likes_count) -
              (b.merged_likes_count ? b.merged_likes_count : b.likes_count)
          )
          .slice(0, 10)
        break
    }

    filteredAnswers.map(
      (filteredAnswer) =>
        (state.all.filter((answer) => answer.guid_text === filteredAnswer.guid_text)[0].isFiltered = true)
    )
    state.nonFilteredAnswers = state.all
    state.all = filteredAnswers
    state.nonFilteredOrder = state.order
    state.order = [...filteredAnswers.keys()]
  },

  moveAnswer(state, { movedIndex, movedAfter, movedLabelGuid }) {
    let movedFromLabelGuid = null
    // set label guid (in case of display by labels)
    if (movedLabelGuid !== -1) {
      movedFromLabelGuid = state.all[state.order[movedIndex]].question_labels_guid_text
      state.all[state.order[movedIndex]].question_labels_guid_text = movedLabelGuid
      this.dispatch("answers/associateLabel", {
        guids: [state.all[state.order[movedIndex]].guid_text],
        question_labels_guid: movedLabelGuid,
      })
    } else {
      movedLabelGuid = state.all[state.order[movedAfter]].question_labels_guid_text
    }

    state.order.splice(movedAfter, 0, state.order.splice(movedIndex, 1)[0])

    // if in label grid mode
    if (
      (Object.keys(state.orderByLabel).length > 0 &&
        state.orderByLabel[movedLabelGuid] !== undefined &&
        state.orderByLabel[movedLabelGuid].length > 0) ||
      movedFromLabelGuid !== null
    ) {
      this.commit("answers/setOrderByLabel", movedLabelGuid)
      if (movedFromLabelGuid !== null) {
        this.commit("answers/setOrderByLabel", movedFromLabelGuid)
      }
    }

    // if grid has EOL elements, rebuild inlineGroups
    if (state.groups.length > 0) {
      this.commit("answers/rebuildInlineGroups")
    }

    state.selected = []
    state.all.map((answer, id) => {
      if (answer.isSelected) {
        state.selected.push(state.order.indexOf(id))
      }
    })

    this.commit("grid/setOrderedBy", { orderedBy: null })
    this.dispatch("answers/updateAnswersOrder")
  },

  multimoveAnswers(state, { movedIndexes, movedAfter, movedLabelGuid = -1 }) {
    let movedFromLabelGuid = []
    // set label guid (in case of display by labels)
    if (movedLabelGuid !== -1) {
      let guids = []
      movedIndexes.map((movedIndex) => {
        movedFromLabelGuid.push(state.all[state.order[movedIndex]].question_labels_guid_text)
        state.all[state.order[movedIndex]].question_labels_guid_text = movedLabelGuid
        guids.push(state.all[state.order[movedIndex]].guid_text)
      })
      this.dispatch("answers/associateLabel", {
        guids: guids,
        question_labels_guid: movedLabelGuid,
      })
    }

    let answersToMove = []
    let answersBeforeCount = 0

    movedIndexes.sort((a, b) => a - b)
    movedIndexes.map((movedIndex, index) => {
      answersToMove.push(state.order.splice(movedIndex - index, 1)[0])
      if (movedIndex < movedAfter) {
        answersBeforeCount++
      }
    })
    if (answersBeforeCount > 0) {
      movedAfter -= answersBeforeCount - 1
    }

    state.order.splice(movedAfter, 0, ...answersToMove)

    // if in label grid mode
    if (
      (Object.keys(state.orderByLabel).length > 0 &&
        state.orderByLabel[movedLabelGuid] !== undefined &&
        state.orderByLabel[movedLabelGuid].length > 0) ||
      movedFromLabelGuid.length > 0
    ) {
      this.commit("answers/setOrderByLabel", movedLabelGuid)
      movedFromLabelGuid.map((guid) => this.commit("answers/setOrderByLabel", guid))
    }

    // if grid has EOL elements, rebuild inlineGroups
    if (state.groups.length > 0) {
      this.commit("answers/rebuildInlineGroups")
    }

    state.selected = []
    state.all.map((answer, id) => {
      if (answer.isSelected) {
        state.selected.push(state.order.indexOf(id))
      }
    })

    this.commit("grid/setOrderedBy", { orderedBy: null })
    this.dispatch("answers/updateAnswersOrder")
  },

  setAnswerFontSize(state, { index, fontSize, lineHeight }) {
    state.all[index].fontSize = fontSize
    state.all[index].lineHeight = lineHeight
  },

  updateGroups(state, answers) {
    this.commit("answers/removeAllGroups")

    // transform order in id
    answers.newGroups.map((newGroup) => {
      newGroup.map((order, index) => {
        newGroup[index] = state.order[order]
      })
    })
    state.groups = answers.newGroups
    answers.topLeftIndexes.map((order) => (state.all[state.order[order]].isGroupTopLeft = true))
    state.selected = []

    this.commit("grid/setOrderedBy", { orderedBy: null })
  },

  removeInlineGroup(state, groupIndex) {
    let lastEOLAnswerIndex = state.groups[state.lastGroupIndex][state.groups[state.lastGroupIndex].length - 1]
    // mouv group after last EOL
    let lastEOLOrder = state.order.indexOf(lastEOLAnswerIndex)
    console.log(state.groups[groupIndex])
    let movedIndexes = state.groups[groupIndex].map((id) => {
      if (state.all[id].merged_answer_guid_text === null) {
        return state.order.indexOf(id)
      }
    })
    this.commit("answers/multimoveAnswers", {
      movedIndexes: movedIndexes,
      movedAfter: lastEOLOrder + 1,
    })

    this.commit("answers/removeSelected")
  },

  rebuildInlineGroups(state) {
    let newGroups = []
    let lastEOLOrder = -1
    for (let id = state.answersCount; id < state.all.length; id++) {
      if (state.all[id].groupIndex === state.lastGroupIndex) {
        lastEOLOrder = state.order.indexOf(id)
      }
    }
    let newGroup = []
    let groupIndex = 0
    let newOrder = [...state.order]
    let removedEOL = null
    let EOLOrders = []
    state.order
      .filter((id, order) => order <= lastEOLOrder)
      .map((id, order) => {
        let newAnswerId = removedEOL !== null && id > removedEOL ? id - 1 : id
        if (state.all[newAnswerId].isEOL === true) {
          if (newGroup.length > 0) {
            newGroups.push(newGroup)
            state.all[newAnswerId].groupIndex = groupIndex
            EOLOrders.push(removedEOL !== null ? order - 1 : order)
            groupIndex++
            newGroup = []
          } else {
            removedEOL = id
            state.all.splice(id, 1)
            newOrder.splice(order, 1)
          }
        } else {
          newGroup.push(id)
        }
      })

    if (removedEOL !== null) {
      EOLOrders.map((order) => {
        if (newOrder[order] > removedEOL) {
          console.log(newOrder[order], " becomes ", newOrder[order] - 1)
          newOrder[order]--
        }
      })
    }

    state.order = newOrder
    state.groups = newGroups
    state.lastGroupIndex = groupIndex - 1 < 0 ? null : groupIndex - 1

    setItem({
      name: "groups[" + state.all[0].question_guid_text + "]",
      value: state.groups,
    })
    setItem({
      name: "lastGroupIndex[" + state.all[0].question_guid_text + "]",
      value: state.lastGroupIndex,
    })
    this.dispatch("answers/saveAnswers")
  },

  inlineGroups(state, fromGridMode) {
    // remove all existing free groups
    if (fromGridMode !== "group") {
      this.commit("answers/removeAllGroups")
    }

    if (state.selected.length === 0 && state.groups.length === 0) {
      return
    }

    // Feature select one or many and create a new group with (not available in group mode)
    if (state.selected.length > 0 && fromGridMode !== "group") {
      // add new group of selected answers, move setected answers to the begining of order and update selected orders
      state.groups.push([])
      let newOrder = [...state.order]
      state.selected.reverse().map((order, index) => {
        let answerId = state.order[order]
        state.groups[0].unshift(answerId)
        newOrder.splice(newOrder.indexOf(answerId), 1)
        newOrder.unshift(answerId)
        state.selected[index] = index
      })
      state.order = newOrder
      state.lastGroupIndex = 0
    }

    let newGroup = null
    let newGroupIndex = null
    // Feature select one and create group with all elements before (only in group mode)
    // Cut group if selected one is already in a group
    if (state.selected.length === 1 && state.groupSelectedIndex === null && fromGridMode === "group") {
      state.groups.map((group, groupIndex) => {
        state.selected.map((order) => {
          if (group.includes(state.order[order])) {
            newGroup = group.splice(0, group.indexOf(state.order[order]) + 1)
            newGroupIndex = groupIndex
            return
          }
        })
      })

      if (newGroup !== null) {
        // insert new Group
        state.groups.push(newGroup)
      } else {
        state.groups.push([])
        // add answer ids in the new group from selected to EOL (desc) in order
        for (let order = state.selected[0]; order > -1 && state.all[state.order[order]].isEOL !== true; order--) {
          state.groups[state.groups.length - 1].unshift(state.order[order])
        }
      }
    }

    // Add EOL answer to the end of answers
    state.all.push({
      guid_text: uuidv4().toUpperCase(),
      text: "Fin de Groupe",
      groupIndex: state.groups.length - 1,
      isEOL: true,
    })

    // Set lastGroupIndex if not splitting an existing group
    if (newGroup === null) {
      state.lastGroupIndex = state.groups.length - 1
    }

    // add EOL answer to order just after the selected one
    state.order.splice(state.selected[state.selected.length - 1] + 1, 0, state.all.length - 1)

    this.commit("answers/removeSelected")
    this.commit("grid/setOrderedBy", { orderedBy: null })

    setItem({
      name: "lastGroupIndex[" + state.all[0].question_guid_text + "]",
      value: state.lastGroupIndex,
    })
    setItem({
      name: "groups[" + state.all[0].question_guid_text + "]",
      value: state.groups,
    })
    setItem({
      name: "answersOrder[" + state.all[0].question_guid_text + "]",
      value: state.order,
    })
    this.dispatch("answers/saveAnswers")
  },

  removeAllEOL() {
    if (state.answersCount === 0) {
      return
    }

    state.lastGroupIndex = null
    state.groups = []
    state.order = state.order.filter((id) => id < state.answersCount)
    state.all.splice(state.answersCount, state.all.length - state.answersCount)
    setItem({
      name: "lastGroupIndex[" + state.all[0].question_guid_text + "]",
      value: state.lastGroupIndex,
    })
    setItem({
      name: "groups[" + state.all[0].question_guid_text + "]",
      value: state.groups,
    })
    setItem({
      name: "answersOrder[" + state.all[0].question_guid_text + "]",
      value: state.order,
    })
    this.dispatch("answers/saveAnswers")
  },

  removeAnswerTopLeft(state, index) {
    state.all[index].isGroupTopLeft = false
  },

  removeGroupsTopLeft() {
    state.all
      .filter((answer) => answer.isGroupTopLeft === true)
      .map((answer) => {
        answer.isGroupTopLeft = false
      })
  },

  removeGroup(state, index) {
    state.groups[index].map((index) => {
      state.all[index].groupIndex = null
      state.all[index].isGroupTopLeft = false
    })
    state.groups.splice(index, 1)
  },

  // remove all free groups
  removeAllGroups(state) {
    this.commit("answers/removeAllEOL")
    this.commit("answers/removeGroupsTopLeft")
    state.groups = []
  },

  selectAnswer(state, id) {
    // avoid individual selection when a group is selected
    if (state.groupSelectedIndex !== null && state.all.length > state.answersCount) {
      return
    }

    state.all[id].isSelected = !state.all[id].isSelected

    this.commit("answers/saveLastSelected")

    const order = state.order.indexOf(id)
    // case deselection
    if (state.selected.includes(order)) {
      state.selected.splice(state.selected.indexOf(order), 1)
      return
    }
    state.selected.push(order)
  },

  selectGrouppedAnswers(state, groupIndex) {
    // case deselection
    if (state.groupSelectedIndex === groupIndex) {
      state.groups[groupIndex].map((id) => {
        state.all[id].isSelected = false
      })
      state.groupSelectedIndex = null
      state.selected = []
      // this.commit('answers/removeGroupsTopLeft')
      return
    }

    this.commit("answers/removeSelected")

    state.groups[groupIndex].map((id) => {
      let order = state.order.indexOf(id)
      state.selected.push(order)
      state.all[id].isSelected = true
    })

    state.groupSelectedIndex = groupIndex
  },

  selectAll(state) {
    this.commit("answers/saveLastSelected")

    state.selected = []
    state.all.map((answer, id) => {
      answer.isSelected = true
      state.selected.push(state.order.indexOf(id))
    })
  },

  selectAllForLabel(state, label) {
    this.commit("answers/saveLastSelected")

    state.selected = []
    state.all.forEach((answer, id) => {
      if (answer.question_labels_guid_text === label.guid_text) {
        answer.isSelected = true
        state.selected.push(state.order.indexOf(id))
      } else {
        answer.isSelected = false
      }
    })
  },

  removeSelected(state) {
    this.commit("answers/saveLastSelected")

    state.selected = []
    state.groupSelectedIndex = null
    state.all
      .filter((answer) => answer.isSelected)
      .map((answer) => {
        answer.isSelected = false
      })
  },

  saveLastSelected(state) {
    state.lastSelected = [...state.selected]
    if (state.groupSelectedIndex) {
      state.lastGroupSelectedIndex = state.groupSelectedIndex
    }
  },

  restorelastSelect(state) {
    /*if (state.selected.length > 0) {
      return
    }*/

    state.selected.map((order) => (state.all[state.order[order]].isSelected = false))
    state.selected = state.lastSelected
    state.selected.map((order) => (state.all[state.order[order]].isSelected = true))
    if (state.lastGroupSelectedIndex) {
      state.groupSelectedIndex = state.lastGroupSelectedIndex
    }
  },

  setGuid(state, { index, guid }) {
    state.all[index].guid_text = guid
  },

  setLabelGuid(state, { index, label_guid }) {
    state.all[index].question_labels_guid_text = label_guid
  },

  setQuestionGuid(state, { index, question_guid }) {
    state.all[index].question_guid_text = question_guid
  },

  setUserGuid(state, { index, user_guid }) {
    state.all[index].user_guid_text = user_guid
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
